import React, { useEffect, useState } from "react";
import { sql } from "../neonClient"; 
import "../Pages/CSS/contact.css";

function Contact() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setErrorMessage("");

    try {
      const result = await sql`
        INSERT INTO contact_messages (name, phone, city, email, comment, created_at)
        VALUES (${name}, ${phone}, ${city}, ${email}, ${comment}, NOW())
      `;
      
      console.log("Inserted data:", result);
      setSuccess(true);

      setTimeout(() => {
        setSuccess(false);
      }, 3000);
      
      setName("");
      setPhone("");
      setCity("");
      setEmail("");
      setComment("");
    } catch (error) {
      console.error("Neon DB insert error:", error.message);
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="contact-form">
        <form onSubmit={handleSubmit}>
          <label htmlFor="name" className="reach-out-subheading">
            Name　
            <span style={{ color: "#c3ff03", fontWeight: 900, marginLeft: "2px" }}>:</span>
          </label>
          <br />
          <input
            className="input"
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <br /><br />

          <label htmlFor="phone" className="reach-out-subheading">
            Phone Number (with country code)　
            <span style={{ color: "#c3ff03", fontWeight: 900 }}>:</span>
          </label>
          <br />
          <input
            className="input"
            type="text"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
          <br /><br />

          <label htmlFor="city" className="reach-out-subheading">
            Location (City, Country)　
            <span style={{ color: "#c3ff03", fontWeight: 900 }}>:</span>
          </label>
          <br />
          <input
            className="input"
            type="text"
            id="city"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            required
          />
          <br /><br />

          <label htmlFor="email" className="reach-out-subheading">
            Email　
            <span style={{ color: "#c3ff03", fontWeight: 900 }}>:</span>
          </label>
          <br />
          <input
            className="input"
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <br /><br />

          <label htmlFor="comment" className="reach-out-subheading">
            Message　
            <span style={{ color: "#c3ff03", fontWeight: 900 }}>:</span>
          </label>
          <br />
          <textarea
            style={{
              width: "100%",
              height: "150px",
              fontFamily: "Degular",
              marginTop: "0.5rem",
            }}
            className="input"
            id="comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            required
          />
          <br />
          <div style={{ textAlign: "right", marginTop: "1rem" }}>
            <button type="submit" className="sub-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>

        {success && <p style={{ color: "#c3ff03", marginTop: "1rem" }}>Message Sent! </p>}
        {errorMessage && <p style={{ color: "red", marginTop: "1rem" }}>{errorMessage}</p>}
      </div>
    </div>
  );
}

export default Contact;
